"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusSelectorCtrl = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var StatusSelectorCtrl = /** @class */ (function () {
    function StatusSelectorCtrl() {
        this.loading = true;
    }
    Object.defineProperty(StatusSelectorCtrl.prototype, "loadingStatuses", {
        get: function () {
            return this.loading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatusSelectorCtrl.prototype, "statusOptions", {
        get: function () {
            this.loading = true;
            var options = [];
            var allCollectionStatuses = [];
            var _loop_1 = function (summary) {
                var collectionStatuses = [];
                var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                if (formSummary != null && formSummary.metadata != null && formSummary.metadata.status != null) {
                    var form = store_1.AppStore.Form.get(formSummary.revision);
                    if (form != null && form !== undefined && form.metadata != null) {
                        for (var _b = 0, _c = form.metadata.getStatusField().options.values; _b < _c.length; _b++) {
                            var value = _c[_b];
                            var values = this_1.getAllValuesFrom(value);
                            values.forEach(function (option) {
                                options.push({ key: option, value: option });
                                collectionStatuses.push(option);
                            });
                        }
                        allCollectionStatuses.push({
                            collectionId: summary.objectId,
                            statuses: collectionStatuses,
                            statusFieldId: form.metadata.statusFieldId
                        });
                    }
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = page_state_1.CurrentState.Tag.collections; _i < _a.length; _i++) {
                var summary = _a[_i];
                _loop_1(summary);
            }
            this.allStatuses = allCollectionStatuses;
            this.loading = false;
            return this.uniqueOptions(options);
        },
        enumerable: false,
        configurable: true
    });
    StatusSelectorCtrl.prototype.selectStatus = function (status) {
        this.selectedStatus = status;
    };
    StatusSelectorCtrl.prototype.getAllValuesFrom = function (value) {
        var values = [];
        if (value.options && value.options.values) {
            for (var _i = 0, _a = value.options.values; _i < _a.length; _i++) {
                var option = _a[_i];
                if (option.options && option.options.values) {
                    for (var _b = 0, _c = option.options.values; _b < _c.length; _b++) {
                        var optionThirdLevel = _c[_b];
                        if (optionThirdLevel.value) {
                            values.push(value.value + ' > ' + option.value + ' > ' + optionThirdLevel.value);
                        }
                    }
                }
                else {
                    if (option.value) {
                        values.push(value.value + ' > ' + option.value);
                    }
                }
            }
        }
        else {
            if (value.value) {
                values.push(value.value);
            }
        }
        return values;
    };
    StatusSelectorCtrl.prototype.uniqueOptions = function (options) {
        var seen = {};
        return options.filter(function (item) {
            return seen.hasOwnProperty(item.value) ? false : (seen[item.value] = true);
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], StatusSelectorCtrl.prototype, "selectedStatus", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], StatusSelectorCtrl.prototype, "loadingStatuses", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], StatusSelectorCtrl.prototype, "statusOptions", null);
    tslib_1.__decorate([
        mobx_1.action
    ], StatusSelectorCtrl.prototype, "selectStatus", null);
    return StatusSelectorCtrl;
}());
exports.StatusSelectorCtrl = StatusSelectorCtrl;
//# sourceMappingURL=status.selector.ctrl.js.map